import React, { Component } from 'react'
import Radium from 'radium'

const styles = {
  option: {
    paddingLeft: 10,
    cursor: 'pointer',
    zIndex: 1001,
    ':hover': {
      backgroundColor: '#efefef',
      color: '#000'
    },
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
}

class Option extends Component {
  onClick(e) {
    const { option, selectOption, filterIndex } = this.props
    e.preventDefault()
    e.stopPropagation()

    if (selectOption) {
      selectOption({
        value: option.value,
        i18nKey: option.i18nKey,
        key: option.key,
        index: option.index,
        filterIndex: filterIndex
      })
    }
  }

  render() {
    const { option, style } = this.props
    let { value } = option
    if (value.length > 52) {
      value = value.substr(0, 51) + '...'
    }
    return (
      <li
        style={{ ...styles.option, ...style }}
        onClick={this.onClick.bind(this)}
        onTouchEnd={this.onClick.bind(this)}
      >
        {value}
        {option.selected ? (
          <svg
            fill={'green'}
            height={'20'}
            style={{ marginRight: 10 }}
            viewBox={'0 -5 20 40'}
            width={'20'}
          >
            <path d={'M0 0h24v24H0z'} fill={'none'} />
            <path d={'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'} />
          </svg>
        ) : null}
      </li>
    )
  }
}

export default Radium(Option)



// WEBPACK FOOTER //
// ./src/components/inputs/option.js